<template>
  <div v-show="ifShow">
    <ul class="closet">
      <li v-for="(item, index) in options" :key="index" @click.stop="select(index)">
        <a :href="item.href" :class="{disabled:item.disabled}">
          <span class="icon">{{ item.icon }}</span>
          <span>{{ $t(item.desc) }}</span>
        </a>
        <ul class="child-list" v-if="index==0">
          <li
            :class="{ active: index == lang }"
            v-for="(op, index) in item.option"
            :key="index"
            @click="changeLang(index)"
          >
            <a>{{ op }}</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import util from "../util";
let lang_map = {
  en: 0,
  cnt: 1,
  cns: 2
};
export default {
  props: {
    ifShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [
        {
          icon: "\ue92e",
          desc: "account.lang",
          option: ["English", "繁體", "简体"],
          href: ""
        },
        {
          icon: "\ue920",
          desc: "account.contact-us",
          href: "mailto:support@gekko.ai"
        },
        { icon: "\ue949", desc: "account.logout", href: "" }
      ],
      disabled: -1
    };
  },
  computed: {
    lang() {
      let lang = this.$i18n.locale;
      return lang_map[lang];
    }
  },
  methods: {
    select(index) {
      if (index == this.disabled) {
        return;
      }
      this.close();
      switch (index) {
        case 2:
          this.logout();
      }
    },
    changeLang(index) {
      if (this.lang !== index) {
        let lang = Object.keys(lang_map)[index];
        this.$i18n.locale = lang;
        util.setCookie("_lang", lang);
      }
    },
    close() {
      this.$emit("closeAccount");
    },
    logout() {
      console.log(this.$reqUrl);
      window.location.replace(`${this.$reqUrl}/logout/`);
      window.event.returnValue = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.closet {
  position: absolute;
  width: 194px;
  bottom: 12px;
  left: 5px;
  background: rgba(254, 254, 254, 1);
  box-shadow: 0px 1px 16px -6px rgba(13, 36, 60, 0.5);
  border-radius: 4px 4px 4px 0px;
  padding: 15px 0;
  z-index: 100;
  li > ul.child-list {
    list-style: none;
    color: $font-base-color;
    & > li {
      padding-left: 50px;
      font-size: 14px;
      line-height: 20px;
      height: 20px;
      a {
        margin-left: 12px;
      }
      &:hover {
        cursor: pointer;
        background-color: $back-color;
      }
      &.active a {
        color: $light-purple;
        position: relative;
        border-bottom: 1px solid $light-purple;
        &::before {
          @include after;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: $light-purple;
          top: 8px;
        }
      }
    }
  }
  & > li {
    list-style: none;
  }
  & > li > a {
    @include flex;
    text-decoration: none;
    height: 30px;
    font-size: 16px;
    color: $font-base-color;
    justify-content: flex-start;
    margin: 5px 0;
    &.disabled {
      background-color: $base-color;
      color: $border-color;
      span:first-child {
        color: $border-color;
      }
    }
    span:first-child {
      color: $font-base-color;
      text-align: center;
      display: inline-block;
      font-size: 20px;
      width: 50px;
    }
    span:last-child {
      margin-left: 0px;
      line-height: 30px;
    }
    &:hover {
      background-color: $back-color;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/closet.vue